import React from 'react';
import ImageWrapper from "../../../Components/ImageWrapper/ImageWrapper";
import CTA from "../../../Components/CTA/CTA";
var HomeInspectionSteps = function HomeInspectionSteps(_ref) {
  var name = _ref.name,
    track = _ref.track,
    _ref$data = _ref.data,
    cta = _ref$data.cta,
    image = _ref$data.image,
    subText = _ref$data.subText;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImageWrapper, {
    image: image
  }), cta && cta.buttons && /*#__PURE__*/React.createElement("div", {
    style: cta.style
  }, cta.buttons.map(function (button, idx) {
    return /*#__PURE__*/React.createElement(CTA, {
      key: "widget_".concat(name, "_cta_").concat(idx),
      button: button,
      widgetKey: name,
      track: track
    });
  })), subText && /*#__PURE__*/React.createElement("div", {
    style: subText.style
  }, subText.text));
};
export default HomeInspectionSteps;